import gql from 'graphql-tag';

export const LISTING_GALLERY_FRAGMENT = gql`
    fragment LISTING_GALLERY_FRAGMENT on ListingData {
        propertyImage {
            filename
            caption
        }
    }
`;
